'use client';

import { createContext, type PropsWithChildren, useMemo, useState } from 'react';

import type { Nullable } from '@libs/core';
import type { AlertBanner } from '../types/alertBanner';

export type AlertBannerProps = Record<string, unknown>;

export interface AlertBannerContextProps {
    /** meant to be an alert rendered at the top of the wrapped component tree */
    alert?: AlertBanner | null;
    /** meant to be an alert rendered lower in the wrapped component tree (above a child component) */
    childAlert?: AlertBanner | null;
    setAlert: (alert: AlertBanner | null | undefined) => void;
    setChildAlert: (alert: AlertBanner | null | undefined) => void;
}
export const AlertBannerContext = createContext<Nullable<AlertBannerContextProps>>(undefined);

export function AlertBannerProvider({ children }: PropsWithChildren<Nullable<AlertBannerProps>>) {
    const [alert, setAlert] = useState<AlertBanner | null>();
    const [childAlert, setChildAlert] = useState<AlertBanner | null>();

    const value = useMemo(
        () => ({
            alert,
            childAlert,
            setAlert,
            setChildAlert,
        }),
        [alert, childAlert]
    );
    return <AlertBannerContext.Provider value={value}>{children}</AlertBannerContext.Provider>;
}
